module.exports = __webpack_public_path__ + "img/3-min.1e58dead.jpg";